import { TrackingCategory, TrackingAction } from './index';
const getUtagFromTrackingData = (pageTrackingData) => (Object.assign(Object.assign({}, pageTrackingData), { 'cp.sessVar': pageTrackingData.session_id, 'cp.abTestGroups': pageTrackingData.abTestGroups ? pageTrackingData.abTestGroups.join('-') : '' }));
export const trackUtagPageView = (pageTrackingData, utag) => {
    utag.view(getUtagFromTrackingData(pageTrackingData));
};
export const trackUtagEvent = (eventTrackingData, utag) => {
    const { label, category = TrackingCategory.STANDARD, action = TrackingAction.CLICK } = eventTrackingData;
    utag.link(Object.assign(Object.assign({}, (utag.data ? utag.data : {})), { label, category: category.replace('tracking-', ''), action }));
};
